import React from 'react';
import { SectionCTA } from './SectionCTA';
import { images } from '../data/content';
export function Author() {
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-20" data-mp="oil2ddje88rv">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[0.85fr_1.15fr] md:gap-14" data-id="element-21" data-mp="9t5blxjv43c6">
        <div className="md:sticky md:top-8" data-id="element-22" data-mp="ergpqkh6x007">
          <img src={images.author} alt="Dr. Elowen Varelli in her pediatric therapy office" className="w-full rounded-3xl object-cover shadow-lg ring-1 ring-brand-100" data-id="element-23" data-mp="es9oay5zwj79" />
          <div className="mt-5 text-center md:text-left" data-id="element-24" data-mp="17eb738ipnj9g">
            <p className="text-sm font-extrabold uppercase tracking-wider text-brand-600" data-id="element-25" data-mp="silgsy6hsjyx">Meet the Author</p>
            <p className="mt-1 text-3xl font-extrabold text-brand-950" data-id="element-26" data-mp="xgwqn8wseuh5">Dr. Elowen Varelli</p>
            <p className="mt-1 text-base text-brand-900/70" data-id="element-27" data-mp="3d8uf4wchv27r">Author of the Sensory Modulation Treatment Roadmap™</p>
          </div>
        </div>

        <div data-id="element-28" data-mp="3i6cga0k9sd57">
          <h2 className="text-balance text-[1.75rem] font-extrabold leading-tight text-brand-950 sm:text-4xl" data-id="element-29" data-mp="1tyafpfggk1w9">
            A Note From Dr. Elowen Varelli
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-brand-900/85" data-id="element-30" data-mp="1p1k3x4borsgn">
            <p data-id="element-31" data-mp="230jpu47tdt94">
              One of the important challenges in pediatric occupational therapy is connecting what we learn during
              assessment with what we plan to do next.
            </p>
            <p data-id="element-32" data-mp="2cvlhb6pkb7ev">
              Understanding sensory modulation concepts is valuable. Recognizing possible sensory-related participation
              challenges is important. But intervention planning introduces another set of questions: which functional
              goals should guide the process, which strategies deserve consideration, and how progress should be
              documented and reviewed.
            </p>
            <p data-id="element-33" data-mp="2vll3nlu0q8el">
              My aim with this material is to help you approach intervention planning as an organized process rather than
              a collection of disconnected activities. You'll find visual frameworks, planning worksheets, strategy
              comparison tools, and fictional educational cases designed to support professional learning.
            </p>
            <p className="rounded-2xl bg-brand-50 p-5 text-base" data-id="element-34" data-mp="1xas6j61n4p5w">
              The Roadmap does not replace your clinical expertise. It does not determine which intervention is
              appropriate for an individual child, and it does not suggest that one sensory strategy will work for every
              situation. Instead, it gives you a practical structure for exploring intervention decisions, documenting
              your reasoning, and keeping functional participation at the center of the planning process.
            </p>
            <p className="font-bold text-brand-950" data-id="element-35" data-mp="lotk1kbp8wa9">
              Because the goal isn't simply to have more intervention ideas. It's to understand how those ideas connect
              with the individual child's needs, goals, and everyday life.
            </p>
            <p className="text-xl font-extrabold italic text-brand-700" data-id="element-36" data-mp="j687ite3s8nc">— Dr. Elowen Varelli</p>
          </div>

          <SectionCTA label="Start Organizing My Intervention Plans" data-id="element-37" data-mp="ebluklsdi815" />
        </div>
      </div>
    </section>;
}